import React, {useContext, useState} from "react";
import {RegionSelectedContext} from "../../contexts/RegionSelectedContext";
import ContentContainer from "../../components/contentWrapper/ContentWrapper";
import HomeContainer from "../home/HomeContainer";
import TotalRankingContainer from "../totalRanking/TotalRankingContainer";
import MarketAnalysisContainer from "../marketAnalysis/MarketAnalysisContainer";
import MarketClusteringContainer from "../marketClustering/MarketClusteringContainer";
import BranchRankingContainer from "../branchRanking/BranchRankingContainer";
import BranchAnalysisContainer from "../branchAnalysis/BranchAnalysisContainer";
import BranchClusteringContainer from "../branchClustering/BranchClusteringContainer";

const MainContent: React.FC = () => {
    // @ts-ignore
    const {regionSelected} = useContext(RegionSelectedContext);
    const [tabSelected, setTabSelected] = useState<number>(1);
    
    const handleTabChange = (id: number) => {
        setTabSelected(id);
    };

    return (
        <>
            <ContentContainer
                handleClick={() => handleTabChange(1)}
                tabSelected={tabSelected}
                tabId={1}
            >
                <HomeContainer
                    isTabSelected={tabSelected === 1}
                />
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(2)}
                tabSelected={tabSelected} tabId={2}
            >
                <TotalRankingContainer isTabSelected={tabSelected === 2} />
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(3)}
                tabSelected={tabSelected}
                tabId={3}
            >
                {
                    regionSelected === "eu" ?
                        <MarketAnalysisContainer isTabSelected={tabSelected === 3} /> :
                        <MarketClusteringContainer isTabSelected={tabSelected === 3} />
                }
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(4)}
                tabSelected={tabSelected}
                tabId={4}
            >
                <BranchRankingContainer isTabSelected={tabSelected === 4} />
            </ContentContainer>

            <ContentContainer
                handleClick={() => handleTabChange(5)}
                tabSelected={tabSelected}
                tabId={5}
            >
                {
                    regionSelected === "eu" ?
                        <BranchAnalysisContainer isTabSelected={tabSelected === 5} /> :
                        <BranchClusteringContainer isTabSelected={tabSelected === 5} />
                }
            </ContentContainer>
        </>
    )
};

export default MainContent;
